import React, { useEffect, useRef, useState } from "react";
import ContentSection from "./ContentSection";
import SidePanel from "./SidePanel";
import KdsService from "../../../services/KdsService";
import { formatdata, groupExpoDataByMenugroup } from "../Expo/children/helper";
import socket from "../../../services/Socket";
import { useSelector } from "react-redux";

const KdsStation = (props) => {
  const wrapperRef2 = useRef(null);
  const [zooming, setZooming] = useState("100%");
  const [kitchenData, setKitchenData] = useState([]);
  const [currentFilter, setCurrentFilter] = useState("");
  const [selectedMenuItemId, setSelectedMenuItemId] = useState("");
  const [sideMenuItems, setSideMenuItems] = useState([]);
  const restaurantId = useSelector((state) => state.admin);
  const [showCompleted, setShowCompleted] = useState(false);

  const getAllKitchenData = () => {
    KdsService.getExpoData(restaurantId, true).then((res) => {
      const dataWithPriority = Object.values(res).flat();
      const groupedData = Object.values(formatdata(dataWithPriority));
      setKitchenData(groupedData);
      const sidepanelItems = groupExpoDataByMenugroup(dataWithPriority);
      setSideMenuItems(sidepanelItems);
    });
  };

  const onAcknoledgeOrder = async (items) => {
    await items.forEach(async ({ cart_item }) => {
      KdsService.updateOrderData(cart_item.id, props.adminRestaurant, {
        is_kitchen_acknowledged: true,
      })
    });
    getAllKitchenData();
  };

  const handleUpdateCartItem = async ({ cart_item }, payload) => {
    await KdsService.updateOrderData(cart_item.id, props.adminRestaurant, {
      ...payload,
    });
  };

  useEffect(() => {
    wrapperRef2.current.style.zoom = "100%";
    socket.connect();

    function onConnect() {
      // console.log('setIsConnected', true);
    }

    function onDisconnect() {
      // console.log('setIsConnected', false)
    }

    socket.on("connect_error", (err) => {
      console.error(`connect_error due to ${err.message}`);
    });

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('ORDER_LIVE_UPDATE', getAllKitchenData);

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('ORDER_LIVE_UPDATE', getAllKitchenData);
    };
  }, []);

  useEffect(() => {
    getAllKitchenData();
  }, []);

  return (
    <div ref={wrapperRef2} className="kitchen_page">
      <div className="left_menu">
        <SidePanel sideMenuItems={sideMenuItems}
          selectedMenuItemId={selectedMenuItemId}
          setSelectedMenuItemId={setSelectedMenuItemId} />
      </div>
      <div className="content_area">
        <ContentSection
          wrapperRef={wrapperRef2}
          setZooming={setZooming}
          kitchenData={kitchenData}
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
          onAcknoledgeOrder={onAcknoledgeOrder}
          handleUpdateCartItem={handleUpdateCartItem}
          zooming={zooming}
          setShowCompleted={setShowCompleted}
          showCompleted={showCompleted}
        />
      </div>
    </div>
  );
};

export default KdsStation;
